import React, { useState } from 'react'
import { FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from "@mui/material";
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { Link, useLocation } from "react-router-dom";
import { BsChatLeftText } from 'react-icons/bs';
import { MdOutlineClose } from 'react-icons/md';




const ViewJob = () => {



 // const { dataID, isErrorID, isSuccessID, isLoadingID } = useAppSelector((state: any) => state.job)


 const [age, setAge] = useState<any>('');

 const { state } = useLocation();




 const systemFields = [
  { fields: "First Name", status: "Yes" },
  { fields: "Last Name", status: "Yes" },
  { fields: "Email", status: "Yes" },
  { fields: "Resume", status: "Yes" },
  { fields: "LinkedIn Url", status: "No" },
  { fields: "Phone", status: "No" },
  { fields: "Curent Salary Status", status: "No" },
  { fields: "Expected Salary Status", status: "No" },
  { fields: "Total work experience", status: "No" }
 ]


 const handleChange = (event: SelectChangeEvent) => {
  setAge(event.target.value as string);
 };

 return (
  <div id='ViewJob__Container'>
   {/* <TopNavigation Time={undefined} setDropDown={false} dropDown={false} /> */}

   <div className="ChatProgressView-body">
    <header className="ChatProgressView-header">
     <div>
      <span className="app-chat--icon">
       <BsChatLeftText />
      </span>

     </div>
     <div className="ChatProgressView-close">
      <Link to={"/activejob"} />
      <MdOutlineClose
       size={25}
       style={{ color: "white", backgroundColor: "" }}
       className="ChatProgressView-close-icon"
      />
     </div>
    </header>

    <main className="app-chat">
    </main>
   </div>
   <main>
    <div id="Job__sections">
     <div className='details'>
      <p className='details__heading'>Job Details</p>
      <div className='details__content'>
       <div className='details__content__left'>
        <label>
         <p>Job Code</p>
        </label>
        {/* @ts-ignore */}
        <p className='subheading'>{state?.name}</p>
        <label>
         <p>Team</p>
        </label>
        <p className='subheading'>Software</p>

        <label>
         <p>Experience Level</p>
        </label>
        <p className='subheading'>Intermediate</p>

        <label><p>Remote</p></label>
        <p>No</p>
       </div>
       <div className='details__content__right'>
        <label>
         <p>Job Function</p>
        </label>
        <p className='subheading'>Develop Application</p>

        <label>
         <p>Employment Type</p>
        </label>
        <p className='subheading'>Full Time</p>

        <label>
         <p>Location</p>
        </label>
        <p className='subheading'>New York, United States of America</p>

        <label>
         <p>Remote</p>
        </label>
        <p className='subheading'>No</p>
       </div>
      </div>
     </div>
     <div className='details'>
      <p className='details__heading'>Recruitment Setting</p>
      <div className='details__content'>
       <div className='details__content__left'>
        <label>
         <p>Accessibility</p>
        </label>
        <p className='subheading'>Public</p>

        <label>
         <p>Hiring Manager</p>
        </label>
        <p className='subheading'>Alan Handerson</p>

        <label>
         <p>Opening Date</p>
        </label>
        {/* @ts-ignore */}
        <p className='subheading'>{state?.email}</p>

        <label>
         <p>Evaluation Parameter</p>
        </label>
        <p>Interview</p>
       </div>
       <div className='details__content__right'>
        <label>
         <p>Number of Openings</p>
        </label>
        <p className='subheading'>5</p>

        <label>
         <p>Recruiter Tagged</p>
        </label>
        <p className='subheading'> Bob Gunmen</p>

        <label>
         <p>Expiry Date</p>
        </label>
        <p className='subheading'>Aug 16, 2022</p>
       </div>
      </div>
     </div>
    </div>

    <div id="description__sections">
     <p className='details__heading'>Job description</p>
     <div className='description'>

      <div className='description__content'>
       <label>
        <p>Qualification</p>
       </label>
       <p className='subheading'>BSC</p>
      </div>
      <div className='description__content'>
       <label>
        <p>Job Role</p>
       </label>
       <p className='subheading'>Junior developer</p>
      </div>

      <div className='description__content'>
       <label><p>Must have Skill</p></label>
       <p className='subheading'>Coding</p>
      </div>

      <div className='description__content'>
       <label><p>Good to have Skil</p></label>
       <p className='subheading'>Communication skill</p>
      </div>
     </div>
    </div>

    <div id="JobApplication__sections">

     <div id="JobApplication__source">
      <p className='details__heading'>Job Application Source</p>
      <form className='JobApplication__source_form'>
       <div className='Source__type'>
        <FormControl fullWidth style={{ marginBottom: "15px" }}>
         <InputLabel id="demo-simple-select-label">Source Type</InputLabel>
         <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={age}
          label="Source Type"
          onChange={handleChange}
         >
          <MenuItem value={10}>Ten</MenuItem>
          <MenuItem value={20}>Twenty</MenuItem>
          <MenuItem value={30}>Thirty</MenuItem>
         </Select>
        </FormControl>
       </div>
       <div className='Source__name'>
        <TextField
         className="TextField-Outline"
         id="outlined-basic"
         label="Source Name"
         variant="outlined"
         fullWidth
        />
       </div>

       <Button variant="contained" size='large' type="submit">Generate Link</Button>
      </form>
      <div className='Source__input__container'>
       <div className='Source__input'>
        <label>
         <p>SOURCE TYPE</p>
        </label>
        <p className='subheading'>External Recruiter</p>
       </div>
       <div className='Source__input'>
        <label>
         <p>SOURCE NAME</p>
        </label>
        <p className='subheading'> Good God</p>
       </div>
       <div className='Source__input'>
        <label>
         <p>LINK</p>
        </label>
        <p className='subheading'><a href="/">https://www.w3.org/Provider/Style/dummy.html</a></p>
       </div>
      </div>
     </div>

    </div>

    <div id="Candidates__field__container">
     <p className='fieldtitle'>Candidates Field</p>
     <div className='Candidates__field__info'>
      <div className='Candidates__field__title'>
       <p>Profile Info</p>
      </div>
      <div id='profile__info__container'>
       <div className='profile__info__fields'>
        <div className='Profile__fields__systemField'>
         <p>System Fields</p>
         <div className='field' >
          {
           systemFields.map((field, i) => (
            <div className='fieldlist' key={i}>
             <p>{field.fields}</p>
            </div>
           ))
          }
         </div>
        </div>
        <div className='Profile__fields__Required'>
         <p>Required *</p>
         <div className='field' >
          {
           systemFields.map((field, i) => (
            <div className='fieldlist' key={i}>
             <p>{field.status}</p>
            </div>
           ))
          }
         </div>
        </div>
       </div>
       <div className='profile__info__fields'>
        <div className='Profile__fields__customField'>
         <p>Custom Fields</p>
        </div>
        <div className='Profile__fields__Required'>
         <p>Required *</p>
        </div>
       </div>
      </div>

     </div>

     <div id="Education__details_container">
      <div className='Education__details_title'>
       <p className='title'>Education Details</p>
      </div>
      <div id='Education__info__container'>
       <div className='Education__details__field'>
        <div className='Education__field' >
         <p>Education Details </p>
        </div>
        <div className='Required__field'>
         <p>No</p>
        </div>
       </div>
       <div></div>
      </div>

     </div>
     <div id="Education__details_container">
      <div className='Education__details_title'>
       <p className='title'>Work Experience</p>
      </div>
      <div id='Education__info__container'>
       <div className='Education__details__field'>
        <div className='Education__field' >
         <p>Work Experience </p>
        </div>
        <div className='Required__field'>
         <p>No</p>
        </div>
       </div>
       <div></div>
      </div>

     </div>
    </div>
   </main>
  </div>
 )
}

export default ViewJob
